import OpportunityIcon from 'src/assets/icons/fi-rr-trophy.svg';
import { FieldMappingsMockUpType } from '../types';

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

export const OpportunityFieldMappings: FieldMappingsMockUpType = {
  id: 'opportunity',
  label: 'Opportunity',
  testRunLabel: 'Opportunities',
  testRunId: 'opportunites',
  icon: OpportunityIcon,
  desc: 'Fields mapped',
  count: '0',
  entity: 'Deals',
  sproutsFields: [
    {
      label: 'Deal Name',
      id: 'name',
      selectedData,
      required: true,
    },
    {
      label: 'Deal Owner',
      id: 'user',
      selectedData,
    },
    {
      label: 'Deal Stage',
      id: 'stage',
      selectedData,
      defaultMapValues: 'dealStage',
    },
    {
      label: 'Close Date',
      id: 'closedDate',
      selectedData,
      testValue: 'closedDate',
    },
    {
      label: 'Closed Won Reason',
      id: 'closedWonReason',
      selectedData,
    },
    {
      label: 'Closed Lost Reason',
      id: 'closedLostReason',
      selectedData,
    },
  ],
};